import { render, staticRenderFns } from "./IconUpdates.vue?vue&type=template&id=fedcb818&"
import script from "./IconUpdates.vue?vue&type=script&lang=js&"
export * from "./IconUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fedcb818')) {
      api.createRecord('fedcb818', component.options)
    } else {
      api.reload('fedcb818', component.options)
    }
    module.hot.accept("./IconUpdates.vue?vue&type=template&id=fedcb818&", function () {
      api.rerender('fedcb818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconUpdates.vue"
export default component.exports